export default __webpack_public_path__ + "static/media/lit fest.536d6baa.jpg";